import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedCurrency from '../../../components/formatted-currency';
import { testId } from 'ui-components/services/testid-service';
import { useFulfillmentPlannerContext } from '../../context';
import style from './style.module.less';

const RateAmount = ({ className = null, shouldShowRate = true }) => {
  const { totalCost } = useFulfillmentPlannerContext();
  if (!shouldShowRate || !totalCost || totalCost.value === 0.0) {
    return <div className={classnames(style['without-rate'], className)}>--</div>;
  }

  return (
    <div className={classnames(style['with-rate'], className)} {...testId('rate-amount')}>
      <FormattedCurrency currencyCode={totalCost.code} value={totalCost.value} />
    </div>
  );
};

RateAmount.propTypes = {
  className: PropTypes.string,
  shouldShowRate: PropTypes.bool,
};

export default RateAmount;
